<template>
    <div class="options">
        <div class="text-primary option" :title="$t('optionsToolbar.api')">
            <v-btn disabled text class="api-link">{{ $t('optionsToolbar.api') }}</v-btn>
        </div>
        <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                    <v-icon>mdi-account</v-icon>
                </v-btn>
            </template>

            <v-list>
                <v-list-item><v-list-item-title>{{ $t('optionsToolbar.profile') }}</v-list-item-title></v-list-item>
                <v-list-item style="cursor: pointer;" @click="openSettingsModal">
                    <v-list-item-title>{{ $t('optionsToolbar.settings') }}</v-list-item-title></v-list-item>
                <v-list-item><v-list-item-title>
                        <v-list-item-title>
                            <a style="cursor: pointer;" @click="handleLogout">{{ $t('optionsToolbar.logout') }}</a>
                        </v-list-item-title>
                    </v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>

</template>
<script>
import { useCoreStore } from '@/store/coreStore';
import { useAuthStore } from '@/store/authStore';
import { mapStores } from 'pinia';

export default {
    computed: {
        ...mapStores(useCoreStore)
    },
    methods: {
        handleLogout() {
            // Era um <router-link to="/login"> que so navegava - a flag ficava
            // de pe e o guard mandava o usuario de volta para dentro.
            useAuthStore().logout();
            this.$router.push('/login');
        },
        openSettingsModal() {
            this.coreStore.handleSettingsModal(true);
        }
    }
}
</script>
<style scoped>
.options {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap:1.5rem;
}
@media (max-width: 1200px) {
  .options {
    display: none;
  }
}
</style>